/**
 * useDisplayTheme — Composes theme colors, font scale, and font family
 * into a single hook. Eliminates the 4-line pattern repeated across 55+ files.
 */

import { useThemeColors } from '../theme';
import { useFontScale, useFontFamily } from './useDisplaySettings';

export function useDisplayTheme() {
  const theme = useThemeColors();
  const fontScale = useFontScale();
  const fontFamily = useFontFamily();
  const ffs = fontFamily ? { fontFamily } : undefined;

  return { theme, fontScale, fontFamily, ffs } as const;
}
